import React from 'react';
import { FiZap, FiCalendar, FiSend, FiTrendingUp, FiTrendingDown, FiMinus } from 'react-icons/fi';

const MomentumIcon = ({ momentum }) => {
  if (momentum === 'rising') return <FiTrendingUp className="h-4 w-4 text-green-500" />;
  if (momentum === 'cooling') return <FiTrendingDown className="h-4 w-4 text-orange-500" />;
  return <FiMinus className="h-4 w-4 text-gray-400" />;
};

const MomentumLabel = ({ momentum }) => {
  const styles = {
    rising: 'text-green-600 bg-green-50',
    steady: 'text-gray-600 bg-gray-50',
    cooling: 'text-orange-600 bg-orange-50',
  };
  return (
    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${styles[momentum] || styles.steady}`}>
      {momentum === 'rising' ? 'Rising' : momentum === 'cooling' ? 'Cooling' : 'Steady'}
    </span>
  );
};

const StreakBar = ({ data }) => {
  const safe = data || {};
  const thisWeek = safe.thisWeek || { applications: 0, interviews: 0 };
  const lastWeek = safe.lastWeek || { applications: 0, interviews: 0 };
  const momentum = safe.momentum || 'steady';

  const items = [
    {
      icon: <FiZap className="h-4 w-4 text-amber-500" />,
      label: `${safe.currentStreak ?? 0}-day streak`,
      sublabel: `Best: ${safe.longestStreak ?? 0}`,
    },
    {
      icon: <FiCalendar className="h-4 w-4 text-blue-500" />,
      label: `Active ${safe.activeDaysThisWeek ?? 0} of ${safe.totalDaysThisWeek ?? 7} days`,
      sublabel: 'This week',
    },
    {
      icon: <FiSend className="h-4 w-4 text-primary-500" />,
      label: `${thisWeek.applications} apps, ${thisWeek.interviews} interviews`,
      sublabel: 'This week',
    },
    {
      icon: <MomentumIcon momentum={momentum} />,
      label: (
        <span className="flex items-center gap-1.5">
          Momentum <MomentumLabel momentum={momentum} />
        </span>
      ),
      sublabel: momentum === 'rising'
        ? `+${Math.round(((thisWeek.applications / Math.max(lastWeek.applications, 1)) - 1) * 100)}% vs last week`
        : 'Compared to last week',
    },
  ];

  return (
    <div className="bg-white shadow-sm rounded-xl border border-gray-100 overflow-hidden">
      <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-gray-100">
        {items.map((item, i) => (
          <div key={i} className="px-4 py-3 flex items-center gap-3">
            <div className="flex-shrink-0 p-2 bg-gray-50 rounded-lg">
              {item.icon}
            </div>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-gray-900 truncate">{item.label}</div>
              <div className="text-xs text-gray-500">{item.sublabel}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StreakBar;
